import React, { useEffect, useMemo } from "react";
import { View, Image } from "react-native";
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
  withSequence,
  Easing,
  useDerivedValue,
  cancelAnimation,
} from "react-native-reanimated";
import { LogoAnimation } from "../../../assets";

const ATLAS_WIDTH = 2000;
const ATLAS_HEIGHT = 1680;

const COLS = 5;
const ROWS = 5;

const FRAME_WIDTH = ATLAS_WIDTH / COLS;
const FRAME_HEIGHT = ATLAS_HEIGHT / ROWS;

const SCALE = 0.8;

const LoginLogoNative = () => {
  const FRAME_SEQUENCE = useMemo(
    () => [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22, // ✅ end at frame 22
    ],
    [],
  );

  const frameIndex = useSharedValue(0);
  const isAnimating = useSharedValue(false);

  const maxFrames = FRAME_SEQUENCE.length;

  const animatedFrame = useDerivedValue(() => {
    "worklet";
    return Math.min(Math.floor(frameIndex.value), maxFrames - 1);
  }, [frameIndex, maxFrames]);

  const animatedStyle = useAnimatedStyle(() => {
    "worklet";
    const frame = animatedFrame.value;

    const col = frame % COLS;
    const row = Math.floor(frame / COLS);

    const left = -col * FRAME_WIDTH;
    const top = -row * FRAME_HEIGHT;

    return {
      transform: [{ translateX: left * SCALE }, { translateY: top * SCALE }],
    };
  }, [animatedFrame]);

  useEffect(() => {
    if (isAnimating.value) {
      return;
    }

    isAnimating.value = true;

    const lastFrame = FRAME_SEQUENCE.length - 1; // Index 21 (22nd frame)
    const frameDuration = 55; // 55ms per frame (~18 FPS for more smoothness)
    const totalDuration = frameDuration * lastFrame;

    // Create discrete frame-by-frame animation for smoothness
    const frameTimings = Array.from({ length: lastFrame + 1 }, (_, i) =>
      withTiming(i, { duration: frameDuration }),
    );

    // Animate through all 22 frames (indices 0-21)
    frameIndex.value = withSequence(...frameTimings);

    return () => {
      cancelAnimation(frameIndex);
      isAnimating.value = false;
    };
  }, [frameIndex, isAnimating]);

  return (
    <View
      style={{
        width: FRAME_WIDTH * SCALE,
        height: FRAME_HEIGHT * SCALE,
        overflow: "hidden",
        backgroundColor: "transparent",
      }}
    >
      <Animated.Image
        source={LogoAnimation}
        style={[
          {
            width: ATLAS_WIDTH * SCALE,
            height: ATLAS_HEIGHT * SCALE,
            position: "absolute",
          },
          animatedStyle,
        ]}
        resizeMode="stretch"
      />
    </View>
  );
};

export default LoginLogoNative;
